<template>
  <base-dialog
    :title="`${isEditMode ? 'Update' : 'Create'} Group`"
    :action="onAction"
    :action-name="`${isEditMode ? 'Update' : 'Create'}`"
    :close="onClose"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-row>
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            v-model="model.label"
            type="text"
            label="Group Label"
          />
          <v-text-field
            outlined
            dense
            v-model="model.description"
            type="text"
            label="Group Description"
          />
          <divisions-drop-down
            :multiple="false"
            :init-division="model.division"
            @select-item="selectedDivision"
          />
          <user-drop-down
            :multiple="true"
            :users="model.uids"
            @select-item="selectedUsers"
          />
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import { isEqual, get, isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import EventsDropDown from '@/components/Common/EventsDropDown.vue'
import DivisionsDropDown from "../Common/DivisionsDropDown"
import UserDropDown from "../Common/UserDropDown"
import BaseDialog from "../Common/BaseDialog"
import { readableCronSchedule } from "../../services/util.service"

export default {
  components: {
    EventsDropDown,
    DivisionsDropDown,
    UserDropDown,
    BaseDialog
  },
  props: {
    group: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      isEditMode: false,
      model: {
        label: '',
        description: '',
        division: '',
        uids: []
      }
    }
  },
  watch: {
    group() {
      console.log('group update', this.group)
      this.model = { ...this.group }
    }
  },
  mounted() {
    this.model = { ...this.group }
    this.isEditMode = !isEmpty(this.group.id)
  },
  methods: {
    ...mapActions([ 'updateGroup', 'createGroup' ]),
    resetModel() {
      this.model.label = ''
      this.model.description = ''
      this.model.division = ''
      this.model.uids = []
    },
    async onAction() {
      const payload = { ...this.model }

      // Set Group covers both CREATE and UPDATE
      // because we know the ID of the entity in both cases
      this.isEditMode
        ? await this.updateGroup(payload)
        : await this.createGroup(payload).then(() => { this.resetModel() })
    },
    async onClose() {

    },
    handleError(e) {
      const errMsg = e.response.data.message
      this.$store.commit('showSnack', { text: errMsg, color: 'error' })
    },
    selectedDivision(divisionId) {
      if (divisionId) {
        this.model.division = divisionId
      }
    },
    selectedUsers(uids) {
      if (Array.isArray(uids)) {
        this.model.uids = uids
      }
    }
  }
}
</script>
